import { render, staticRenderFns } from "./LegendElement.vue?vue&type=template&id=2d1c8cb0&scoped=true"
import script from "./LegendElement.vue?vue&type=script&lang=js"
export * from "./LegendElement.vue?vue&type=script&lang=js"
import style0 from "./LegendElement.vue?vue&type=style&index=0&id=2d1c8cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c8cb0",
  null
  
)

export default component.exports